import utils from '@utils';

export const main = (values: any) => {
  const errors: any = {};

  utils.validate.vaildDate(values, errors, 'currentDate');

  return errors;
};
